import { render, staticRenderFns } from "./flexicommsTrap.vue?vue&type=template&id=745885be&"
import script from "./flexicommsTrap.vue?vue&type=script&lang=js&"
export * from "./flexicommsTrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports